import React from "react";

export default function PricingComponent() {
  return (
    <div className="about_area style-three d-flex align-items-center justify-content-center" 
    // style={{
    //     height: "700px",
    //     backgroundImage: "url('/assets/images/abstract-pricing.jpg')",
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat"
    //   }}
    >
      <div className="container text-center">
        <div className="section_main_title1 pricing-title">
          <h1>The Right Plan for Every Growth Stage</h1>
          <p>Scale confidently with transparent pricing - from small teams to enterprises, choose your <br/> plan with no hidden fees or commitments.</p>
        </div>
      </div>
    </div>
  );
}